export default __webpack_public_path__ + "static/media/blur-830.d7f5b9a6.png";